import { useEffect, useState } from "react";
import { getValueList, getValueListByCode, updateValueList } from "../../api";
import {
  Button,
  Center,
  Container,
  Group,
  Loader,
  Select,
  Table,
  Text,
  Title,
} from "@mantine/core";
import { useStore } from "../../store";

export default function ValueListDetails({ params }) {
  const [valueList, setValueList] = useState(null);
  const [isSaving, setIsSaving] = useState(false);
  const profile = useStore((state) => state.profile);

  useEffect(() => {
    // getValueList(params.id).then((data) => {
    getValueListByCode(params.marketplaceId, params.listCode).then((data) => {
      setValueList(data);
    });
  }, []);

  if (!valueList)
    return (
      <Container size="xl">
        <Center>
          <Loader />
        </Center>
      </Container>
    );

  return (
    <Container size="xl">
      <Title order={1}>{valueList.label}</Title>

      {profile.role === "GlobalAdmin" && (
        <>
          <Text c="dimmed">ID: {valueList.id}</Text>
          <Text c="dimmed">
            MarketplaceId: {valueList.destinationMarketplaceId}
          </Text>

          <Text c="dimmed">Last fetched: {valueList.lastFetched}</Text>
          <Text c="dimmed">First fetched: {valueList.idCreated}</Text>

          <Group my="lg" align="flex-end">
            <Select
              style={{ flex: 1 }}
              searchable
              clearable
              label="Fallback Value"
              data={valueList.values.map((p) => ({
                label: p.label,
                value: p.code,
              }))}
              value={
                valueList.values.find((p) => p.label == valueList.fallbackValue)
                  ?.code
              }
              placeholder="Select fallback value"
              onChange={(_value) => {
                console.log("Setting value ", _value);
                setValueList({ ...valueList, fallbackValue: _value });
              }}
            />

            <Button
              loading={isSaving}
              onClick={() => {
                setIsSaving(true);
                console.log("Saving value list ", valueList);
                updateValueList(params.marketplaceId, valueList)
                  .then((data) => {
                    console.log("Saved value list ", data);
                    setValueList(data);
                  })
                  .finally(() => {
                    setIsSaving(false);
                  });
              }}
            >
              Save
            </Button>
          </Group>
        </>
      )}

      <Table>
        <Table.Thead>
          <Table.Tr>
            <Table.Th>Code</Table.Th>
            <Table.Th>Label</Table.Th>
            <Table.Th>Label i18n</Table.Th>
          </Table.Tr>
        </Table.Thead>
        <Table.Tbody>
          {valueList.values.map((value) => (
            <Table.Tr>
              <Table.Td>{value.code}</Table.Td>
              <Table.Td>{value.label}</Table.Td>
              <Table.Td>
                {value.labelTranslations.map((trx) => (
                  <Text fz="sm" key={value.code + trx.locale}>
                    {trx.locale}: {trx.value}
                  </Text>
                ))}
              </Table.Td>
            </Table.Tr>
          ))}
        </Table.Tbody>
      </Table>
    </Container>
  );
}
